// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__6tFrq","productName":"Table_productName__2skxv"};